const uniq = require('lodash/uniq');
const isPlainObject = require('lodash/isPlainObject');

const isPromise = require('./is-promise');
const isObservable = require('./is-observable');

/**
 * Get a string representation of a value's type, as used in error messages.
 * @param {any} value Value to inspect
 * @return {string} String representation of the value's type
 */
function getValueType(value) {
  return getType(value, []);
}

module.exports = getValueType;

function getType(value, visited) { // eslint-disable-line complexity
  switch (typeof value) {
    case 'undefined': return 'undefined';
    case 'boolean': return 'boolean';
    case 'number': return 'number';
    case 'string': return 'string';
    case 'function': return 'Function';
    case 'symbol': return 'Symbol';
    case 'object': {
      if (value === null) { return 'null'; }
      if (value instanceof Date) { return 'Date'; }
      if (value instanceof RegExp) { return 'RegExp'; }
      if (value instanceof Map) { return 'Map'; }
      if (value instanceof Set) { return 'Set'; }
      if (value instanceof Error) { return 'Error'; }
      if (isObservable(value)) { return 'Observable'; }
      if (isPromise(value)) { return 'Promise'; }
      if (visited.includes(value)) { return '[Circular]'; }
      if (Array.isArray(value)) {
        const valueTypes = uniq(value.map((item) => getType(item, visited.concat([value]))));
        return `Array<${valueTypes.join(' | ')}>`;
      }
      if (isPlainObject(value)) {
        const propertyTypes = Object.keys(value).map(
          (key) => [key, getType(value[key], visited.concat([value]))]
        );
        return `{${propertyTypes.map(([key, type]) => `${key}: ${type}`).join(', ')}}`;
      }
      return value.constructor.name || value.toString();
    }
    default:
      return value.toString();
  }
}
